import { INav, INavLink, INavLinkGroup, INavProps, INavStyles, Nav } from '@fluentui/react/lib/Nav';

export interface IPNavProps extends INavProps {}

export type IPNavLink = INavLink;

/** The imperative handle behind componentRef: focus() moves the keyboard into the nav. */
export type IPNavRef = INav;

export type IPNavLinkGroup = INavLinkGroup;

export type IPNavStyles = INavStyles;

export const IPNav = (props: IPNavProps) => {
  return <Nav {...props} />;
};
